import { useRef, useCallback, useEffect } from "react";

// ============================================
// 1. Fixed Infinite Scroll Hook
// ============================================
const useInfiniteScroll = (Loading, hasMore, setCurrPage) => {
  const scrollTimeoutRef = useRef(null);
  const isLoadingRef = useRef(Loading);
  const hasMoreRef = useRef(hasMore);

  // Keep refs in sync so the scroll handler always has latest values
  useEffect(() => {
    isLoadingRef.current = Loading;
  }, [Loading]);

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    const handleScroll = () => {
      // Debounce: Clear any pending scroll trigger
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      // Wait for scroll to "settle" before triggering next page
      scrollTimeoutRef.current = setTimeout(() => {
        const screenHeight = window.innerHeight;
        const totalHeight = document.documentElement.scrollHeight;
        const scrollTop = document.documentElement.scrollTop;

        if (screenHeight + scrollTop + 100 >= totalHeight) {
          if (!isLoadingRef.current && hasMoreRef.current) {
            const savedScrollY = window.scrollY;
            setCurrPage((p) => p + 1);
            // Restore scroll position after new items are rendered
            requestAnimationFrame(() => {
              window.scrollTo({ top: savedScrollY, behavior: "instant" });
            });
          }
        }
      }, 200); // 200ms debounce — prevents rapid-fire page increments
    };

    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      document.removeEventListener("scroll", handleScroll);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []); // Empty deps — refs handle the latest values
};

export default useInfiniteScroll;
